var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"main"}},[_c('stripe-pricing-table',{attrs:{"pricing-table-id":"prctbl_1Q3ra2LUgmmDlShmAtmknXJE","publishable-key":"pk_test_kSALC1zzott1ubjImcTbIvUw"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }